import { inject, Injectable } from '@angular/core';

import { OkModalComponent } from '../../components/modals/ok-modal/ok-modal.component';
import { ModalService } from './../modal.service';
import { ignoreModalConfirm, ignoreModalError } from '../../helpers';

@Injectable({
  providedIn: 'root',
})
export class ModalInfoService {
  private readonly modalService = inject(ModalService);

  infoSmall(header: string, message: string) {
    const { modal, component } = this.modalService.openSmall<OkModalComponent>(OkModalComponent);
    component.header.set(header);
    component.message.set(message);
    modal.result.then(ignoreModalConfirm, ignoreModalError);
  }
}
